(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog"] && !Shopify.designMode) return;
  try {
    
  class YGMainBlogLatest extends HTMLElement {
    constructor() {
      super();

      this.handleSlideChange = this.handleSlideChange.bind(this);
      this.handlePaginationUpdate = this.handlePaginationUpdate.bind(this);
      this.handleAutoplayStart = this.handleAutoplayStart.bind(this);
      this.handleAutoplayStop = this.handleAutoplayStop.bind(this);
      this.animationFrame = null;
    }

    connectedCallback() {
      this.setupSwiper();
    }

    disconnectedCallback() {
      if (this.animationFrame) {
        window.cancelAnimationFrame(this.animationFrame);
      }

      if (this.swiper) {
        this.swiper.off('slideChangeTransitionStart', this.handleSlideChange);
        this.swiper.off('paginationUpdate', this.handlePaginationUpdate);
        this.swiper.off('autoplayStart', this.handleAutoplayStart);
        this.swiper.off('autoplayStop', this.handleAutoplayStop);
      }
    }

    get swiperElement() {
      return this.querySelector('yg-swiper');
    }

    setupSwiper() {
      if (!this.swiperElement) return;

      const connectSwiper = () => {
        if (!this.isConnected) return;

        if (!this.swiperElement.swiper) {
          this.animationFrame = window.requestAnimationFrame(connectSwiper);
          return;
        }

        this.swiper = this.swiperElement.swiper;
        this.swiper.on('slideChangeTransitionStart', this.handleSlideChange);
        this.swiper.on('paginationUpdate', this.handlePaginationUpdate);
        this.swiper.on('autoplayStart', this.handleAutoplayStart);
        this.swiper.on('autoplayStop', this.handleAutoplayStop);
        this.restartActiveBulletAnimation();
      };

      connectSwiper();
    }

    handleSlideChange() {
      this.restartActiveBulletAnimation();
    }

    handlePaginationUpdate() {
      this.restartActiveBulletAnimation();
    }

    handleAutoplayStart() {
      this.restartActiveBulletAnimation();
    }

    handleAutoplayStop() {
      this.stopBulletAnimation();
    }

    getActiveBullet() {
      return this.swiper?.pagination?.el?.querySelector('.swiper-pagination-bullet-active');
    }

    restartActiveBulletAnimation() {
      const activeBullet = this.getActiveBullet();

      this.querySelectorAll('.swiper-pagination-bullet').forEach((bullet) => {
        bullet.classList.remove('is-progressing');
      });

      if (!activeBullet) return;

      activeBullet.offsetHeight;
      activeBullet.classList.add('is-progressing');
    }

    stopBulletAnimation() {
      this.querySelectorAll('.swiper-pagination-bullet').forEach((bullet) => {
        bullet.classList.remove('is-progressing');
      });
    }
  }

  if (!window.customElements.get('yg-main-blog-latest')) {
    window.customElements.define('yg-main-blog-latest', YGMainBlogLatest);
  }

  class YGMainBlogRecent extends HTMLElement {
    constructor() {
      super();

      this.handleToggle = this.handleToggle.bind(this);
    }

    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-recent-post-item]'));
      this.button = this.querySelector('.yg-main-blog__show-more');

      if (!this.items.length || !this.button) {
        return;
      }

      this.button.addEventListener('click', this.handleToggle);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleToggle);
    }

    handleToggle() {
      const isExpanded = this.classList.toggle('is-expanded');

      this.items.forEach((item) => {
        item.hidden = false;
      });

      if (!isExpanded) {
        this.items.forEach((item, index) => {
          if (index >= this.getPostsToShow()) {
            item.hidden = true;
          }
        });
      }

      this.button.textContent = isExpanded ? this.button.dataset.showLessText : this.button.dataset.showMoreText;
      this.button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    }

    getPostsToShow() {
      return parseInt(this.dataset.postsToShow, 10) || 6;
    }
  }

  if (!window.customElements.get('yg-main-blog-recent')) {
    window.customElements.define('yg-main-blog-recent', YGMainBlogRecent);
  }

  class YGTagSelect extends HTMLElement {
    constructor() {
      super();

      this.handleToggle = this.handleToggle.bind(this);
      this.handleOverlayClick = this.handleOverlayClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('.yg-blog-tags-dropdown');
      this.overlay = this.querySelector('.yg-blog-tags-dropdown-overlay');

      if (!this.button) {
        return;
      }

      this.button.addEventListener('click', this.handleToggle);
      this.overlay?.addEventListener('click', this.handleOverlayClick);
      document.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleToggle);
      this.overlay?.removeEventListener('click', this.handleOverlayClick);
      document.removeEventListener('keydown', this.handleKeydown);
    }

    handleToggle() {
      if (this.classList.contains('is-open')) {
        this.close();
      } else {
        this.open();
      }
    }

    handleOverlayClick() {
      this.close();
    }

    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
      }
    }

    open() {
      this.classList.add('is-open');
      this.button?.setAttribute('aria-expanded', 'true');

      if (this.overlay) {
        this.overlay.style.display = 'block';
      }
    }

    close() {
      this.classList.remove('is-open');
      this.button?.setAttribute('aria-expanded', 'false');

      if (this.overlay) {
        this.overlay.style.display = 'none';
      }
    }
  }

  if (!window.customElements.get('yg-tag-select')) {
    window.customElements.define('yg-tag-select', YGTagSelect);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-accordion-video-01"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  class YGAccordionVideo01 extends YGUtils {
    constructor() {
      super();
      this.swiperInstance = null;
      this.isMobileMode = false;
      this.isInitializing = true; // 标记正在初始化
      this.handleResize = this.handleResize.bind(this);
      this.debouncedResize = this.debounce(this.handleResize.bind(this), 150);
      this.handleItemHover = this.handleItemHover.bind(this);
      this.restartActiveBulletAnimation = this.restartActiveBulletAnimation.bind(this);
      this.currentActiveItem = null;
    }

    get items() {
      return this.querySelectorAll('.yg-accordion-item');
    }

    connectedCallback() {
      // 初始化时根据当前屏幕尺寸设置正确的模式和监听器
      this.handleResize();
      window.addEventListener('resize', this.debouncedResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.debouncedResize);
      this.destroySwiper();
      this.removeHoverListeners();
    }

    initSwiper() {
      if (this.swiperInstance) return;

      // 如果是 folding card 模式且在移动端，不初始化轮播
      if (this.classList.contains('yg-accordion-folding-card') && this.isMobileMode) {
        return;
      }

      const galleryContainer = this.querySelector('.yg-accordion-item-container');
      if (!galleryContainer) return;

      const enableAutoplay = this.dataset.enableAutoplay === 'true';
      const autoplayDelay = Number(this.dataset.autoplayDelay) || 3000;
      const paginationEl = galleryContainer.querySelector('.yg-accordion-pagination');

      this.swiperInstance = new Swiper(galleryContainer, {
        spaceBetween: 16,
        slidesPerView: 1,
        autoplay: enableAutoplay ? {
          delay: autoplayDelay,
          disableOnInteraction: false,
        } : false,
        autoHeight: true,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        on: {
          slideChange: () => {
            // 暂停所有视频
            this.items.forEach((item) => {
              this.controlVideo(item, 'pause');
            });
            // 播放当前活动的slide的视频
            const activeSlide = galleryContainer.querySelector('.swiper-slide-active');
            if (activeSlide) {
              this.controlVideo(activeSlide, 'play');
            }
          }
        },
        breakpoints: {
          220: {
            slidesPerView: 1,
            spaceBetween: 16,
          },
        },
      });

      // 初始化时播放第一个活动的slide的视频
      this.swiperInstance.on('slideChangeTransitionStart', this.restartActiveBulletAnimation);
      this.swiperInstance.on('paginationUpdate', this.restartActiveBulletAnimation);

      if (enableAutoplay) {
        this.swiperInstance.autoplay?.start();
        this.restartActiveBulletAnimation();
      }

      setTimeout(() => {
        const activeSlide = galleryContainer.querySelector('.swiper-slide-active');
        if (activeSlide) {
          this.controlVideo(activeSlide, 'play');
        }
      }, 100);
    }

    destroySwiper() {
      if (this.swiperInstance) {
        this.swiperInstance.off('slideChangeTransitionStart', this.restartActiveBulletAnimation);
        this.swiperInstance.off('paginationUpdate', this.restartActiveBulletAnimation);
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }

    restartActiveBulletAnimation() {
      const paginationEl = this.swiperInstance?.pagination?.el;
      const activeBullet = paginationEl?.querySelector('.swiper-pagination-bullet-active');

      if (this.dataset.enableAutoplay !== 'true') {
        paginationEl?.querySelectorAll('.is-progressing').forEach((bullet) => {
          bullet.classList.remove('is-progressing');
        });
        return;
      }

      if (!activeBullet) return;

      paginationEl.querySelectorAll('.is-progressing').forEach((bullet) => {
        bullet.classList.remove('is-progressing');
      });

      activeBullet.offsetHeight;
      activeBullet.classList.add('is-progressing');
    }

    handleResize() {
      const width = window.innerWidth;
      const shouldBeMobile = width < 700;
      const modeChanged = shouldBeMobile !== this.isMobileMode;

      // 更新当前模式
      this.isMobileMode = shouldBeMobile;

      if (modeChanged || this.isInitializing) {
        if (shouldBeMobile) {
          // 切换到移动端模式
          this.removeHoverListeners();
          this.clearActiveItems();
          // 延迟初始化轮播，确保DOM已准备好
          setTimeout(() => this.initSwiper(), 50);
        } else {
          // 切换到PC端模式
          this.destroySwiper();
          this.addHoverListeners();
          // 重新激活当前项目（如果有的话）
          if (this.currentActiveItem) {
            this.currentActiveItem.classList.add('active');
            this.controlVideo(this.currentActiveItem, 'play');
          }
        }
      }

      // 标记初始化完成
      this.isInitializing = false;
    }

    addHoverListeners() {
      this.items.forEach((item) => {
        item.removeEventListener('mouseenter', this.handleItemHover);
        item.addEventListener('mouseenter', this.handleItemHover);
        item.removeEventListener('mouseleave', this.handleItemHover);
        item.addEventListener('mouseleave', this.handleItemHover);
      });
    }

    removeHoverListeners() {
      this.items.forEach((item) => {
        item.removeEventListener('mouseenter', this.handleItemHover);
        item.removeEventListener('mouseleave', this.handleItemHover);
      });
    }

    clearActiveItems() {
      this.items.forEach((item) => item.classList.remove('active'));
      this.currentActiveItem = null;
    }

    controlVideo(item, action) {
      const videoElement = item.querySelector('yg-video');
      if (videoElement && videoElement.pauseVideo && videoElement.playVideo) {
        // 检查是否有实际的视频内容
        const hasVideoContent = videoElement.type === 'video' && videoElement.videoContainer;
        if (hasVideoContent || videoElement.template) {
          if (action === 'play') {
            videoElement.playVideo();
          } else if (action === 'pause') {
            videoElement.pauseVideo();
          }
        }
      }
    }

    handleItemHover(e) {
      const type = e.type;
      const target = e.currentTarget;

      if (type === 'mouseenter') {
        this.items.forEach((item) => {
          item.classList.remove('active');
          this.controlVideo(item, 'pause');
        });
        target.classList.add('active');
        this.controlVideo(target, 'play');
        this.currentActiveItem = target;
      } else if (type === 'mouseleave') {
        setTimeout(() => {
          const hoverItem = [...this.items].find((item) => item.matches(':hover'));
          if (!hoverItem && this.currentActiveItem) {
            this.currentActiveItem.classList.add('active');
            this.controlVideo(this.currentActiveItem, 'play');
          }
        }, 10);
      }
    }
  }

  if (!window.customElements.get('yg-accordion-video-01')) {
    window.customElements.define('yg-accordion-video-01', YGAccordionVideo01);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-banner-tabs-01"] && !Shopify.designMode) return;
  try {
    
  class YGBannerTabs01 extends HTMLElement {
    constructor() {
      super();
      this.handleTabClick = this.handleTabClick.bind(this);
    }

    get sectionsEl() {
      if (this._sectionsEl) return this._sectionsEl;

      this._sectionsEl = {
        'tabs-container': this.querySelector('.yg-tabs-title-container'),
        'tabs': this.querySelectorAll('.yg-banner-tab-title'),
        'swiper': this.querySelector('.yg-banner-swiper')
      };

      return this._sectionsEl;
    }

    connectedCallback() {
      if (this.isInitialized) return;

      this.isInitialized = true;
      this.sectionsEl.tabs.forEach((tab, index) => {
        tab.dataset.index = index;
        tab.addEventListener('click', this.handleTabClick);
      });

      this.bindSwiper();
    }

    disconnectedCallback() {
      this.sectionsEl.tabs.forEach((tab) => {
        tab.removeEventListener('click', this.handleTabClick);
      });

      if (this.slideChangeHandler && this.sectionsEl.swiper?.swiper) {
        this.sectionsEl.swiper.swiper.off('slideChange', this.slideChangeHandler);
      }

      this.isInitialized = false;
      this.isSwiperBound = false;
    }

    bindSwiper() {
      if (!this.sectionsEl['tabs-container']) return;
      if (!this.sectionsEl.swiper?.swiper) {
        if (this.isConnected) {
          window.setTimeout(() => this.bindSwiper(), 100);
        }
        return;
      }
      if (this.isSwiperBound) return;

      this.slideChangeHandler = (event) => {
        const realIndex = event.realIndex;
        const tab = this.sectionsEl.tabs[realIndex];

        if (tab) {
          this.sectionsEl['tabs-container'].scrollItemIntoView?.(tab, { behavior: 'smooth' });
          this.sectionsEl['tabs-container'].toggleClass(tab, realIndex);
        }
      };

      this.sectionsEl.swiper.swiper.on('slideChange', this.slideChangeHandler);
      this.isSwiperBound = true;
    }

    handleTabClick(event) {
      const tab = event.currentTarget;
      const index = Number(tab.dataset.index);

      if (!Number.isNaN(index) && this.sectionsEl.swiper?.swiper) {
        this.sectionsEl.swiper.swiper.slideTo(index);
      }
    }
  }
  if (!window.customElements.get('yg-banner-tabs-01')) {
    window.customElements.define('yg-banner-tabs-01', YGBannerTabs01);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-comfort-scroll"] && !Shopify.designMode) return;
  try {
    
  class YGComfortScroll extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.ticking = false;
      this.isProgrammaticScrolling = false;
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handleItemClick = this.handleItemClick.bind(this);
      this.handleMobileAccordionClick = this.handleMobileAccordionClick.bind(this);
      this.handleProgrammaticScrollEnd = this.handleProgrammaticScrollEnd.bind(this);
      this.update = this.update.bind(this);
    }

    connectedCallback() {
      this.track = this.querySelector('.yg-comfort-scroll__desktop-track');
      this.items = Array.from(this.querySelectorAll('.yg-comfort-scroll__item'));
      this.mediaItems = Array.from(this.querySelectorAll('.yg-comfort-scroll__media'));
      this.mobileAccordionItems = Array.from(this.querySelectorAll('.yg-comfort-scroll__mobile-accordion-item'));
      this.mobileAccordionTriggers = Array.from(this.querySelectorAll('.yg-comfort-scroll__mobile-accordion-trigger'));
      this.stepCount = Number(this.dataset.stepCount) || this.items.length;
      this.isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.items.forEach((item) => {
        item.addEventListener('click', this.handleItemClick);
      });
      this.mobileAccordionTriggers.forEach((trigger) => {
        trigger.addEventListener('click', this.handleMobileAccordionClick);
      });

      this.resizeObserver = new ResizeObserver(this.handleResize);
      this.resizeObserver.observe(this);

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);

      this.handleResize();
      this.setActive(0);
    }

    disconnectedCallback() {
      this.items?.forEach((item) => {
        item.removeEventListener('click', this.handleItemClick);
      });
      this.mobileAccordionTriggers?.forEach((trigger) => {
        trigger.removeEventListener('click', this.handleMobileAccordionClick);
      });
      this.resizeObserver?.disconnect();
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);

      if (this.animationFrame) {
        window.cancelAnimationFrame(this.animationFrame);
      }

      if (this.scrollEndTimer) {
        window.clearTimeout(this.scrollEndTimer);
      }
    }

    handleResize() {
      const style = window.getComputedStyle(this);
      this.stepDistance = parseFloat(style.getPropertyValue('--yg-comfort-scroll-step')) || 520;
      this.handleScroll();
    }

    handleScroll() {
      if (!this.track || window.matchMedia('(max-width: 699px)').matches) {
        return;
      }

      if (this.isProgrammaticScrolling) {
        window.clearTimeout(this.scrollEndTimer);
        this.scrollEndTimer = window.setTimeout(this.handleProgrammaticScrollEnd, 150);
        return;
      }

      if (this.ticking) {
        return;
      }

      this.ticking = true;
      this.animationFrame = window.requestAnimationFrame(this.update);
    }

    handleItemClick(event) {
      const target = event.currentTarget;
      const index = Number(target.dataset.index) || 0;

      this.setActive(index);

      if (!this.track || this.isReducedMotion) {
        return;
      }

      this.isProgrammaticScrolling = true;
      window.clearTimeout(this.scrollEndTimer);
      this.scrollEndTimer = window.setTimeout(this.handleProgrammaticScrollEnd, 150);

      const trackTop = this.track.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: trackTop + (this.stepDistance * index),
        behavior: 'smooth'
      });
    }

    handleMobileAccordionClick(event) {
      const trigger = event.currentTarget;
      const item = trigger.closest('.yg-comfort-scroll__mobile-accordion-item');
      const index = this.mobileAccordionItems.indexOf(item);

      if (index >= 0) {
        this.setActiveMobileAccordion(index);
      }
    }

    setActiveMobileAccordion(index) {
      this.mobileAccordionItems.forEach((item, itemIndex) => {
        const isActive = itemIndex === index;
        item.classList.toggle('is-active', isActive);
        item.querySelector('.yg-comfort-scroll__mobile-accordion-trigger')?.setAttribute('aria-expanded', String(isActive));
      });
    }

    handleProgrammaticScrollEnd() {
      this.isProgrammaticScrolling = false;
      this.scrollEndTimer = null;
      this.handleScroll();
    }

    update() {
      this.ticking = false;

      if (!this.track || this.isReducedMotion) {
        return;
      }

      const rect = this.track.getBoundingClientRect();
      const rawIndex = Math.round(Math.max(0, -rect.top) / Math.max(1, this.stepDistance));
      const nextIndex = Math.min(Math.max(rawIndex, 0), this.stepCount - 1);

      this.setActive(nextIndex);
    }

    setActive(index) {
      if (index === this.currentIndex && this.items?.[index]?.classList.contains('is-active')) {
        return;
      }

      this.currentIndex = index;

      this.items?.forEach((item, itemIndex) => {
        const isActive = itemIndex === index;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.mediaItems?.forEach((media, mediaIndex) => {
        media.classList.toggle('is-active', mediaIndex === index);
      });
    }
  }

  if (!window.customElements.get('yg-comfort-scroll')) {
    window.customElements.define('yg-comfort-scroll', YGComfortScroll);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-dynamic-media"] && !Shopify.designMode) return;
  try {
    
class YGDynamicMedia extends HTMLElement {
  connectedCallback() {
    this.media = this.querySelector('.yg-dynamic-media__media');
    this.video = this.querySelector('.yg-dynamic-media__video');
    this.image = this.querySelector('.yg-dynamic-media__image');

    this.lastScrollY = window.scrollY;

    this.bindVideoPlayback();
    requestAnimationFrame(() => this.bindVideoPlayback());

    this.disableVideoClickPlayback();
    this.bindViewportPlayback();
  }

  enterMedia() {
    if (!this.media) return;

    this.media.classList.add('yg-dynamic-media__media--playing');
  }

  leaveMedia() {
    if (!this.media) return;

    this.media.classList.remove('yg-dynamic-media__media--playing');
  }

  bindVideoPlayback() {
    if (!this.video) return;
    if (this.video.__ygDynamicMediaBound) return;

    const playVideo = this.video.playVideo?.bind(this.video);
    const pauseVideo = this.video.pauseVideo?.bind(this.video);

    if (!playVideo) return;

    this.video.__ygDynamicMediaBound = true;

    this.video.playVideo = (...args) => {
      const result = playVideo(...args);
      this.enterMedia();
      return result;
    };

    if (pauseVideo) {
      this.video.pauseVideo = (...args) => {
        this.leaveMedia();

        window.setTimeout(() => {
          pauseVideo(...args);
        }, 800);
      };
    }
  }

  disableVideoClickPlayback() {
    const videoButton = this.video?.querySelector('.yg-video-button');

    if (!videoButton) return;

    videoButton.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
      },
      true
    );
  }

  playMediaAnimation() {
    if (this.image) {
      this.enterMedia();
      return;
    }

    this.bindVideoPlayback();
    this.video?.playVideo?.();
  }

  bindViewportPlayback() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {

          const currentScrollY = window.scrollY;
          const scrollingDown = currentScrollY > this.lastScrollY;
          this.lastScrollY = currentScrollY;

          if (entry.isIntersecting) {

            this.playMediaAnimation();

          } else {

            /**
             * 只有向上滚动离开视口时恢复缩小状态
             */
            if (!scrollingDown && entry.boundingClientRect.top > 0) {
              this.leaveMedia();
            }

            /**
             * 如果视频向下滚出屏幕，可以暂停播放
             */
            if (scrollingDown && this.video) {
              this.video.pauseVideo?.();
            }

          }
        });
      },
      {
        threshold: 0.05,
      }
    );

    observer.observe(this);
  }
}

if (!window.customElements.get('yg-dynamic-media')) {
  window.customElements.define('yg-dynamic-media', YGDynamicMedia);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-expert-reviews"] && !Shopify.designMode) return;
  try {
    
  class YGExpertReviews extends HTMLElement {
    connectedCallback() {
      this.$tabs = Array.from(this.querySelectorAll('[data-review-tab]'));
      this.$panels = Array.from(this.querySelectorAll('[data-review-panel]'));
      this.$progressItems = Array.from(this.querySelectorAll('[data-review-progress]'));
      this.handleTabClick = this.handleTabClick.bind(this);
      this.handleTabKeydown = this.handleTabKeydown.bind(this);

      this.addEventListener('click', this.handleTabClick);
      this.addEventListener('keydown', this.handleTabKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleTabClick);
      this.removeEventListener('keydown', this.handleTabKeydown);
    }

    handleTabClick(event) {
      const $tab = event.target.closest('[data-review-tab]');

      if (!$tab || !this.contains($tab)) {
        return;
      }

      this.setActiveReview(Number($tab.dataset.reviewIndex));
    }

    handleTabKeydown(event) {
      const $tab = event.target.closest('[data-review-tab]');

      if (!$tab || !this.contains($tab)) {
        return;
      }

      const activeIndex = this.$tabs.indexOf($tab);
      let nextIndex = null;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextIndex = (activeIndex + 1) % this.$tabs.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextIndex = (activeIndex - 1 + this.$tabs.length) % this.$tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.$tabs.length - 1;
      }

      if (nextIndex === null) {
        return;
      }

      event.preventDefault();
      this.setActiveReview(nextIndex, true);
    }

    setActiveReview(index, shouldFocus = false) {
      const $nextTab = this.$tabs[index];

      if (!$nextTab) {
        return;
      }

      this.$tabs.forEach(($tab, tabIndex) => {
        const isActive = tabIndex === index;
        $tab.classList.toggle('is-active', isActive);
        $tab.setAttribute('aria-selected', String(isActive));
        $tab.tabIndex = isActive ? 0 : -1;
      });

      this.$panels.forEach(($panel, panelIndex) => {
        const isActive = panelIndex === index;
        $panel.classList.toggle('is-active', isActive);
        $panel.setAttribute('aria-hidden', String(!isActive));
      });

      this.$progressItems.forEach(($progressItem, progressIndex) => {
        $progressItem.classList.toggle('is-active', progressIndex === index);
      });

      $nextTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

      if (shouldFocus) {
        $nextTab.focus();
      }
    }
  }

  if (!window.customElements.get('yg-expert-reviews')) {
    window.customElements.define('yg-expert-reviews', YGExpertReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-grid-v4"] && !Shopify.designMode) return;
  try {
    
  class YGGridV4Carousel extends HTMLElement {
    constructor() {
      super();
      this.handleButtonClick = this.handleButtonClick.bind(this);
      this.updateControls = this.updateControls.bind(this);
    }

    connectedCallback() {
      this.viewport = this.querySelector('[data-carousel-viewport]');
      this.buttons = Array.from(this.querySelectorAll('[data-carousel-button]'));

      if (!this.viewport) {
        return;
      }

      this.buttons.forEach((button) => button.addEventListener('click', this.handleButtonClick));
      this.viewport.addEventListener('scroll', this.updateControls, { passive: true });
      window.addEventListener('resize', this.updateControls);
      this.updateControls();
    }

    disconnectedCallback() {
      this.buttons?.forEach((button) => button.removeEventListener('click', this.handleButtonClick));
      this.viewport?.removeEventListener('scroll', this.updateControls);
      window.removeEventListener('resize', this.updateControls);
    }

    handleButtonClick(event) {
      const direction = event.currentTarget.dataset.carouselButton === 'next' ? 1 : -1;

      this.viewport.scrollBy({
        left: direction * this.getScrollAmount(),
        behavior: 'smooth',
      });
    }

    getScrollAmount() {
      const card = this.viewport.querySelector('.yg-grid-v4__card');
      const track = this.viewport.querySelector('.yg-grid-v4__track');
      const columnGap = track ? parseFloat(getComputedStyle(track).columnGap) || 0 : 0;

      return card ? card.getBoundingClientRect().width + columnGap : this.viewport.clientWidth * 0.85;
    }

    updateControls() {
      const maximumScroll = Math.max(this.viewport.scrollWidth - this.viewport.clientWidth, 0);
      const atStart = this.viewport.scrollLeft <= 1;
      const atEnd = this.viewport.scrollLeft >= maximumScroll - 1;

      this.buttons.forEach((button) => {
        button.disabled = button.dataset.carouselButton === 'previous' ? atStart : atEnd;
      });
    }
  }

  if (!window.customElements.get('yg-grid-v4-carousel')) {
    window.customElements.define('yg-grid-v4-carousel', YGGridV4Carousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-motion-reveal"] && !Shopify.designMode) return;
  try {
    
  class YGMotionReveal extends HTMLElement {
    connectedCallback() {
      this.triggerOnce = this.dataset.triggerOnce !== 'false';
      this.isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.toggleButton = this.querySelector('.yg-motion-reveal__link');
      this.handleToggle = this.handleToggle.bind(this);

      this.toggleButton?.addEventListener('click', this.handleToggle);

      if (this.isReducedMotion) {
        this.classList.add('is-zooming', 'is-complete');
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.playDesktopAnimation();

            if (this.triggerOnce) {
              this.observer?.unobserve(this);
            }

            return;
          }

          if (!this.triggerOnce) {
            this.classList.remove('is-zooming', 'is-complete');
            this.hasPlayed = false;
          }
        });
      }, {
        threshold: 0.28,
        rootMargin: '0px 0px -12% 0px'
      });

      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.toggleButton?.removeEventListener('click', this.handleToggle);

      if (this.completeTimer) {
        window.clearTimeout(this.completeTimer);
      }
    }

    handleToggle() {
      const isExpanded = this.classList.toggle('is-expanded');
      this.toggleButton?.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    }

    playDesktopAnimation() {
      if (this.hasPlayed || window.matchMedia('(max-width: 699px)').matches) {
        return;
      }

      this.hasPlayed = true;
      this.classList.add('is-zooming');

      this.completeTimer = window.setTimeout(() => {
        this.classList.add('is-complete');
      }, 1050);
    }
  }

  if (!window.customElements.get('yg-motion-reveal')) {
    window.customElements.define('yg-motion-reveal', YGMotionReveal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-process-steps-v1"] && !Shopify.designMode) return;
  try {
    
  class YGProcessSteps extends HTMLElement {
    #sectionEl;
    constructor() {
      super();
      this.currentStepIndex = 0;
    }

    get $sectionEl() {
      if (this.#sectionEl) return this.#sectionEl

      this.#sectionEl = {
        'accordionList': this.querySelectorAll('.yg-process-steps-item'),
        'progressBars': this.querySelectorAll('.yg-process-steps-progress-bar'),
        'controls': this.querySelectorAll('.yg-process-steps-media')
      }

      return this.#sectionEl
    }

    connectedCallback() {
      document.addEventListener('YG:dropdown-open', (event) => {
        if (event.detail.id) {
          this.currentStep(event.detail.id);
        }
      });
      document.addEventListener('YG:progress-end', (event) => {
        if (event.detail.id) {
          this.nextStep(event.detail.id);
        }
      });
    }

    nextStep(id) {
      if (!this.isCurrentStep(id)) {
        return;
      }
      this.$sectionEl['accordionList'].forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          let indexNext = i == this.$sectionEl['accordionList'].length - 1 ? 0 : i + 1;
          this.currentStepIndex = indexNext;
        }
      });
      
      this.$sectionEl['accordionList'][this.currentStepIndex]?.openDropdown();
    }

    currentStep(id) {
      if (!this.isCurrentStep(id)) {
        return;
      }
      this.setActiveControl(id);
      this.startProgressForId(id);
      this.playVideo(id);
    }

    isCurrentStep(id) {
      let isCurrentStep = false;
      this.$sectionEl['accordionList'].forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          isCurrentStep = true;
        }
      });
      return isCurrentStep;
    }

    setActiveControl(id) {
      this.$sectionEl['controls'].forEach((item) => {
        if (item.getAttribute('data-id') === id) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }

    startProgressForId(id) {
      this.$sectionEl['progressBars']?.forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          this.currentStepIndex = i;
          item.startProgress();
        } else {
          item.stopProgress();
        }
      });
    }

    getVideoById(id) {
      let videoEl = null;
      this.$sectionEl['controls'].forEach((item) => {
        if (item.querySelector('yg-video')?.getAttribute('data-id') === id) {
          videoEl = item.querySelector('yg-video');
        }
      });
      return videoEl;
    }

    pauseAllVideos() {
      this.$sectionEl['controls'].forEach((item) => {
        const videoEl = item.querySelector('yg-video');
        if (videoEl) {
          videoEl.pauseVideo();
        }
      });
    }

    playVideo(id) {
      this.pauseAllVideos();
      const videoEl = this.getVideoById(id);
      if (videoEl) {
        videoEl.playVideo();
      }
    }
  }

  if (!window.customElements.get('yg-process-steps')) {
    window.customElements.define('yg-process-steps', YGProcessSteps);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-process-steps-v3"] && !Shopify.designMode) return;
  try {
    
  class YGProcessStepsV3 extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.handleStepClick = this.handleStepClick.bind(this);
      this.handleStepKeydown = this.handleStepKeydown.bind(this);
      this.handleAnimationEnd = this.handleAnimationEnd.bind(this);
    }

    connectedCallback() {
      this.steps = Array.from(this.querySelectorAll('.yg-process-steps-v3__step'));
      this.panels = Array.from(this.querySelectorAll('.yg-process-steps-v3__media-panel'));
      this.isAutoplay = this.dataset.autoplay === 'true';

      this.steps.forEach((step) => {
        step.addEventListener('click', this.handleStepClick);
        step.addEventListener('keydown', this.handleStepKeydown);
        step.querySelector('.yg-process-steps-v3__bar')?.addEventListener('animationend', this.handleAnimationEnd);
      });

      this.setActive(0);
    }

    disconnectedCallback() {
      this.steps?.forEach((step) => {
        step.removeEventListener('click', this.handleStepClick);
        step.removeEventListener('keydown', this.handleStepKeydown);
        step.querySelector('.yg-process-steps-v3__bar')?.removeEventListener('animationend', this.handleAnimationEnd);
      });
    }

    handleStepClick(event) {
      const index = Number(event.currentTarget.dataset.index);
      this.setActive(index);
    }

    handleStepKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      const index = Number(event.currentTarget.dataset.index);
      this.setActive(index);
    }

    handleAnimationEnd(event) {
      if (!this.isAutoplay || !event.target.closest('.is-active')) {
        return;
      }

      this.setActive(this.getNextIndex());
    }

    getNextIndex() {
      const count = this.steps.length;
      return count > 0 ? (this.currentIndex + 1) % count : 0;
    }

    restartAnimation(element, selector) {
      const animatedElement = element?.querySelector(selector);
      if (!animatedElement) {
        return;
      }

      animatedElement.style.animation = 'none';
      animatedElement.offsetHeight;
      animatedElement.style.animation = '';
    }

    setActive(index) {
      if (Number.isNaN(index)) {
        return;
      }

      this.currentIndex = index;
      this.steps.forEach((step, stepIndex) => {
        const isActive = stepIndex === index;
        step.classList.toggle('is-active', isActive);
        step.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (isActive) {
          this.restartAnimation(step, '.yg-process-steps-v3__bar');
        }
      });

      this.panels.forEach((panel, panelIndex) => {
        panel.classList.toggle('is-active', panelIndex === index);
      });
    }
  }

  if (!window.customElements.get('yg-process-steps-v3')) {
    window.customElements.define('yg-process-steps-v3', YGProcessStepsV3);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-specifications"] && !Shopify.designMode) return;
  try {
    
  class YGProductSpecifications extends HTMLElement {
    constructor() {
      super();
      this.handleUnitClick = this.handleUnitClick.bind(this);
      this.handleShowMoreClick = this.handleShowMoreClick.bind(this);
    }

    connectedCallback() {
      this.unitButtons = Array.from(this.querySelectorAll('[data-unit]'));
      this.valueElements = Array.from(this.querySelectorAll('[data-value-in][data-value-cm]'));
      this.showMoreButton = this.querySelector('[data-show-more]');
      this.showMoreText = this.querySelector('[data-show-more-text]');
      this.showMoreLabel = this.dataset.showMoreLabel || 'Show More';
      this.showLessLabel = this.dataset.showLessLabel || 'Show Less';
      this.currentUnit = this.dataset.defaultUnit || 'in';

      this.unitButtons.forEach((button) => {
        button.addEventListener('click', this.handleUnitClick);
      });

      this.showMoreButton?.addEventListener('click', this.handleShowMoreClick);
      this.setUnit(this.currentUnit);
      this.updateShowMoreText();
    }

    disconnectedCallback() {
      this.unitButtons?.forEach((button) => {
        button.removeEventListener('click', this.handleUnitClick);
      });

      this.showMoreButton?.removeEventListener('click', this.handleShowMoreClick);
    }

    handleUnitClick(event) {
      this.setUnit(event.currentTarget.dataset.unit);
    }

    handleShowMoreClick() {
      this.classList.toggle('is-expanded');
      this.updateShowMoreText();
      this.scrollToSectionTop();
    }

    scrollToSectionTop() {
      window.requestAnimationFrame(() => {
        const sectionElement = this.closest('.shopify-section') || this;
        const stickyOffset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height')) || 0;
        const targetTop = sectionElement.getBoundingClientRect().top + window.scrollY - stickyOffset;

        window.scrollTo({
          top: Math.max(targetTop, 0),
          behavior: 'smooth'
        });
      });
    }

    setUnit(unit) {
      if (unit !== 'in' && unit !== 'cm') {
        return;
      }

      this.currentUnit = unit;
      this.dataset.currentUnit = unit;
      this.unitButtons.forEach((button) => {
        const isActive = button.dataset.unit === unit;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.valueElements.forEach((element) => {
        element.textContent = unit === 'cm' ? element.dataset.valueCm : element.dataset.valueIn;
      });
    }

    updateShowMoreText() {
      if (!this.showMoreText) {
        return;
      }

      this.showMoreText.textContent = this.classList.contains('is-expanded') ? this.showLessLabel : this.showMoreLabel;
    }
  }

  if (!window.customElements.get('yg-product-specifications')) {
    window.customElements.define('yg-product-specifications', YGProductSpecifications);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-recovery-tabs"] && !Shopify.designMode) return;
  try {
    
  class YGRecoveryTabs extends HTMLElement {
    constructor() {
      super();
      this.isVisible = false;
      this.handleClick = this.handleClick.bind(this);
      this.handleTransition = this.handleTransition.bind(this);
      this.handleIntersect = this.handleIntersect.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick);
      this.observer = new IntersectionObserver(this.handleIntersect, { threshold: 0.24 });
      this.observer.observe(this);
      window.requestAnimationFrame(() => this.syncMedia());
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.observer?.disconnect();
      window.clearTimeout(this.syncTimer);
      window.clearTimeout(this.videoTimer);
    }

    handleIntersect(entries) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        this.classList.add('is-visible');
        this.isVisible = true;
        this.activateInitialPanel();
        this.syncMedia();
        this.observer?.disconnect();
      });
    }

    handleClick(event) {
      if (!event.target.closest('.tab-title')) {
        return;
      }

      window.requestAnimationFrame(() => this.handleTransition());
    }

    handleTransition() {
      this.pauseInactiveVideos();
      window.clearTimeout(this.syncTimer);
      this.syncTimer = window.setTimeout(() => this.syncMedia(), 120);
    }

    activateInitialPanel() {
      const firstTitle = this.querySelector('.yg-recovery-tabs__tab');
      const firstPanel = this.panels[0];

      if (!firstTitle || !firstPanel) {
        return;
      }

      this.querySelectorAll('.yg-recovery-tabs__tab').forEach((title) => {
        title.classList.toggle('is-active', title === firstTitle);
      });

      this.panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel === firstPanel);
      });
    }

    get panels() {
      return Array.from(this.querySelectorAll('.yg-recovery-tabs__panel'));
    }

    get activePanel() {
      return this.querySelector('.yg-recovery-tabs__panel.is-active');
    }

    pauseInactiveVideos() {
      this.panels.forEach((panel) => {
        if (panel === this.activePanel) {
          return;
        }

        panel.querySelectorAll('yg-video').forEach((video) => {
          video.pauseVideo?.();
        });
      });
    }

    syncMedia() {
      this.pauseInactiveVideos();

      if (!this.isVisible && !this.classList.contains('is-visible')) {
        return;
      }

      this.playActiveVideo();
    }

    playActiveVideo() {
      window.clearTimeout(this.videoTimer);
      this.videoTimer = window.setTimeout(() => {
        this.activePanel?.querySelectorAll('yg-video').forEach((video) => {
          video.playVideo?.();
        });
      }, 240);
    }
  }

  if (!window.customElements.get('yg-recovery-tabs')) {
    window.customElements.define('yg-recovery-tabs', YGRecoveryTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-scroll-slide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGScrollSlide extends HTMLElement {
      constructor() {
        super();
        this.animationFrame = null;
        this.scenes = [];
        this.handleScroll = this.handleScroll.bind(this);
        this.updateScenes = this.updateScenes.bind(this);
      }

      connectedCallback() {
        this.scenes = Array.from(this.querySelectorAll('[data-scroll-scene]'));
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.querySelectorAll('video').forEach((video) => {
          video.muted = true;
          video.play().catch(() => {});
        });

        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleScroll);
        this.updateScenes();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleScroll);

        if (this.animationFrame !== null) {
          window.cancelAnimationFrame(this.animationFrame);
          this.animationFrame = null;
        }
      }

      handleScroll() {
        if (this.animationFrame !== null) return;
        this.animationFrame = window.requestAnimationFrame(this.updateScenes);
      }

      updateScenes() {
        this.animationFrame = null;
        const viewportHeight = window.innerHeight;

        this.scenes.forEach((scene) => {
          if (this.prefersReducedMotion.matches) {
            scene.style.removeProperty('--yg-scroll-slide-opacity');
            return;
          }

          const rect = scene.getBoundingClientRect();
          const sceneCenter = rect.top + rect.height / 2;
          const centerDistance = Math.abs(sceneCenter - viewportHeight / 2);
          const opacity = Math.max(0, Math.min(1, 1 - centerDistance / (viewportHeight * 0.5)));
          scene.style.setProperty('--yg-scroll-slide-opacity', opacity.toFixed(3));
        });
      }
    }

    if (!customElements.get('yg-scroll-slide')) {
      customElements.define('yg-scroll-slide', YGScrollSlide);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-scroll-video"] && !Shopify.designMode) return;
  try {
    
  class YGScrollVideo extends HTMLElement {
    constructor() {
      super();
      this.isActive = false;
      this.ticking = false;
      this.isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.update = this.update.bind(this);
    }

    connectedCallback() {
      this.track = this.querySelector('.yg-scroll-video__track');

      if (!this.track) {
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.isActive = entry.isIntersecting;

          if (this.isActive) {
            this.handleScroll();
            this.playVideos();
          } else {
            this.pauseVideos();
          }
        });
      }, { rootMargin: '25% 0px' });

      this.observer.observe(this);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);

      if (this.animationFrame) {
        window.cancelAnimationFrame(this.animationFrame);
      }
    }

    handleResize() {
      this.scrollDistance = Number(this.dataset.scrollDistance) || window.innerHeight || 900;
      this.handleScroll();
    }

    handleScroll() {
      if (this.ticking) {
        return;
      }

      this.ticking = true;
      this.animationFrame = window.requestAnimationFrame(this.update);
    }

    update() {
      this.ticking = false;

      if (!this.isActive && !this.isReducedMotion) {
        return;
      }

      const progress = this.isReducedMotion ? 1 : this.getProgress();
      const introProgress = this.smoothStep(this.normalize(progress, 0, 0.58));
      const detailsProgress = this.smoothStep(this.normalize(progress, 0.38, 0.88));
      const mediaScale = this.lerp(1, 1.045, progress);
      const mediaY = this.lerp(0, -18, progress);
      const introOpacity = 1 - introProgress;
      const introY = this.lerp(0, -28, introProgress);
      const detailsY = this.lerp(28, 0, detailsProgress);

      this.style.setProperty('--yg-scroll-video-media-scale', mediaScale.toFixed(6));
      this.style.setProperty('--yg-scroll-video-media-y', mediaY.toFixed(2));
      this.style.setProperty('--yg-scroll-video-intro-opacity', introOpacity.toFixed(3));
      this.style.setProperty('--yg-scroll-video-intro-y', introY.toFixed(2));
      this.style.setProperty('--yg-scroll-video-details-opacity', detailsProgress.toFixed(3));
      this.style.setProperty('--yg-scroll-video-details-y', detailsY.toFixed(2));
    }

    getProgress() {
      const rect = this.track.getBoundingClientRect();
      const distance = Math.max(1, this.scrollDistance);

      return Math.min(Math.max(-rect.top / distance, 0), 1);
    }

    normalize(value, start, end) {
      return Math.min(Math.max((value - start) / (end - start), 0), 1);
    }

    smoothStep(value) {
      return value * value * (3 - 2 * value);
    }

    lerp(start, end, progress) {
      return start + (end - start) * progress;
    }

    playVideos() {
      this.querySelectorAll('yg-video').forEach((video) => {
        video.playVideo?.();
      });
    }

    pauseVideos() {
      this.querySelectorAll('yg-video').forEach((video) => {
        video.pauseVideo?.();
      });
    }
  }

  if (!window.customElements.get('yg-scroll-video')) {
    window.customElements.define('yg-scroll-video', YGScrollVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-slide-video"] && !Shopify.designMode) return;
  try {
    
  class YGSlideVideo extends HTMLElement {
    constructor() {
      super();
      this.handleToggleClick = this.handleToggleClick.bind(this);
      this.handleSlideChange = this.handleSlideChange.bind(this);
      this.handlePaginationUpdate = this.handlePaginationUpdate.bind(this);
      this.isPaused = this.classList.contains('is-paused') || this.dataset.autoplay !== 'true';
    }

    connectedCallback() {
      this.toggleButton?.addEventListener('click', this.handleToggleClick);
      this.setupSwiper();
    }

    disconnectedCallback() {
      this.toggleButton?.removeEventListener('click', this.handleToggleClick);

      if (this.swiper) {
        this.swiper.off('slideChangeTransitionStart', this.handleSlideChange);
        this.swiper.off('paginationUpdate', this.handlePaginationUpdate);
      }
    }

    get swiperElement() {
      return this.querySelector('yg-swiper');
    }

    get toggleButton() {
      return this.querySelector('[data-yg-slide-video-toggle]');
    }

    setupSwiper() {
      if (!this.swiperElement) return;

      const connectSwiper = () => {
        if (!this.swiperElement.swiper) {
          window.requestAnimationFrame(connectSwiper);
          return;
        }

        this.swiper = this.swiperElement.swiper;
        this.swiper.on('slideChangeTransitionStart', this.handleSlideChange);
        this.swiper.on('paginationUpdate', this.handlePaginationUpdate);

        if (this.isPaused) {
          this.pause();
        } else {
          this.play();
        }

        this.restartProgress();
      };

      connectSwiper();
    }

    handleToggleClick() {
      if (this.isPaused) {
        this.play();
      } else {
        this.pause();
      }
    }

    handleSlideChange() {
      this.pauseInactiveVideos();
      this.playActiveVideo();
      this.restartProgress();
    }

    handlePaginationUpdate() {
      this.restartProgress();
    }

    play() {
      this.isPaused = false;
      this.classList.remove('is-paused');
      this.toggleButton?.setAttribute('aria-label', 'Pause carousel');
      this.swiper?.autoplay?.start();
      this.pauseInactiveVideos();
      this.playActiveVideo();
      this.restartProgress();
    }

    pause() {
      this.isPaused = true;
      this.classList.add('is-paused');
      this.toggleButton?.setAttribute('aria-label', 'Play carousel');
      this.swiper?.autoplay?.stop();
      this.pauseAllVideos();
    }

    restartProgress() {
      const activeBullet = this.swiper?.pagination?.el?.querySelector('.swiper-pagination-bullet-active');

      this.querySelectorAll('.swiper-pagination-bullet.is-progressing').forEach((bullet) => {
        bullet.classList.remove('is-progressing');
      });

      if (!activeBullet || this.isPaused) return;

      activeBullet.offsetHeight;
      activeBullet.classList.add('is-progressing');
    }

    getActiveSlide() {
      return this.swiper?.slides?.[this.swiper.activeIndex] || this.querySelector('.swiper-slide-active');
    }

    playActiveVideo() {
      const activeSlide = this.getActiveSlide();
      activeSlide?.querySelectorAll('yg-video').forEach((video) => {
        video.playVideo?.();
      });
    }

    pauseInactiveVideos() {
      const activeSlide = this.getActiveSlide();

      this.querySelectorAll('yg-video').forEach((video) => {
        if (!activeSlide?.contains(video)) {
          video.pauseVideo?.();
        }
      });
    }

    pauseAllVideos() {
      this.querySelectorAll('yg-video').forEach((video) => {
        video.pauseVideo?.();
      });
    }
  }

  if (!window.customElements.get('yg-slide-video')) {
    window.customElements.define('yg-slide-video', YGSlideVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-slideshow"] && !Shopify.designMode) return;
  try {
    
  class YGSlideshowDeferredVideo extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.handleInteraction = this.loadVideo.bind(this);
      this.handlePageLoad = this.schedulePageLoadPlayback.bind(this);

      ['pointerdown', 'touchstart', 'keydown', 'scroll'].forEach((eventName) => {
        window.addEventListener(eventName, this.handleInteraction, {
          once: true,
          passive: eventName !== 'keydown',
          signal: this.abortController.signal,
        });
      });

      if (document.readyState === 'complete') {
        this.schedulePageLoadPlayback();
      } else {
        window.addEventListener('load', this.handlePageLoad, {
          once: true,
          signal: this.abortController.signal,
        });
      }
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.cancelScheduledPlayback();
    }

    schedulePageLoadPlayback() {
      if (this.hasAttribute('initialized')) {
        return;
      }

      if ('requestIdleCallback' in window) {
        this.idleCallbackId = window.requestIdleCallback(() => this.loadVideo(), { timeout: 2000 });
      } else {
        this.fallbackTimerId = window.setTimeout(() => this.loadVideo(), 1000);
      }
    }

    cancelScheduledPlayback() {
      if (this.idleCallbackId != null && 'cancelIdleCallback' in window) {
        window.cancelIdleCallback(this.idleCallbackId);
        this.idleCallbackId = null;
      }

      if (this.fallbackTimerId != null) {
        window.clearTimeout(this.fallbackTimerId);
        this.fallbackTimerId = null;
      }
    }

    loadVideo() {
      if (this.hasAttribute('initialized')) {
        return;
      }

      const template = this.querySelector('.yg-lavenne-slideshow__video-template');

      if (!template) {
        return;
      }

      this.setAttribute('initialized', '');
      this.abortController?.abort();
      this.cancelScheduledPlayback();
      template.replaceWith(template.content.cloneNode(true));

      requestAnimationFrame(() => {
        const videoMediaElements = Array.from(this.querySelectorAll('video-media'));

        videoMediaElements.forEach((media) => {
          media.querySelector('video')?.addEventListener('playing', () => {
            this.setAttribute('video-loaded', '');
          }, { once: true });
        });

        const slide = this.closest('.slideshow__slide');
        const videoMedia = videoMediaElements
          .filter((media) => media.offsetParent !== null)
          .pop();
        const video = videoMedia?.querySelector('video');

        if (!slide?.classList.contains('is-selected') || !videoMedia || !video) {
          return;
        }

        if (this.dataset.videoTimingMode === 'video_duration') {
          this.syncPlayerDuration(video);
        }

        videoMedia.play({ restart: true });
      });
    }

    syncPlayerDuration(video) {
      const updateDuration = () => {
        const carousel = this.closest('slideshow-carousel');
        const player = carousel?.player;

        if (!player || !Number.isFinite(video.duration)) {
          return;
        }

        player.setDuration(video.duration);
        player.resume({ restart: true });
      };

      if (video.readyState >= 1) {
        updateDuration();
      } else {
        video.addEventListener('loadedmetadata', updateDuration, { once: true });
      }
    }
  }

  if (!window.customElements.get('yg-slideshow-deferred-video')) {
    window.customElements.define('yg-slideshow-deferred-video', YGSlideshowDeferredVideo);
  }

  class YGSlideshowIndicator extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.items = Array.from(this.querySelectorAll('.yg-lavenne-slideshow__indicator-item'));
      this.progress = this.querySelector('.yg-lavenne-slideshow__indicator-track > .yg-lavenne-slideshow__indicator-progress');
      this.carousel = document.getElementById(this.getAttribute('aria-controls'));
      this.mobileMediaQuery = window.matchMedia('(max-width: 699px)');

      this.setDuration(this.dataset.cycleSpeed);
      this.bindItems();
      this.setActiveIndex(this.carousel?.selectedIndex || 0);

      if (this.carousel) {
        this.carousel.addEventListener('carousel:select', this.handleCarouselSelect.bind(this), {
          signal: this.abortController.signal,
        });
        this.carousel.addEventListener('carousel:change', this.handleCarouselChange.bind(this), {
          signal: this.abortController.signal,
        });

        this.mobileMediaQuery.addEventListener('change', () => {
          this.setActiveIndex(this.carousel?.selectedIndex || 0);
          this.restartProgress();
        }, {
          signal: this.abortController.signal,
        });

        requestAnimationFrame(() => this.bindPlayer());
      }
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.playerAbortController?.abort();
    }

    bindItems() {
      this.items.forEach((item) => {
        item.addEventListener(
          'click',
          () => {
            const slideIndex = Number(item.dataset.slideIndex);

            if (this.carousel && Number.isInteger(slideIndex)) {
              this.carousel.select(slideIndex);
            }
          },
          {
            signal: this.abortController.signal,
          }
        );
      });
    }

    bindPlayer() {
      if (!this.carousel?.player) {
        return;
      }

      this.playerAbortController = new AbortController();
      this.carousel.player.addEventListener('player:start', this.handlePlayerStart.bind(this), {
        signal: this.playerAbortController.signal,
      });
      this.carousel.player.addEventListener('player:pause', this.handlePlayerPause.bind(this), {
        signal: this.playerAbortController.signal,
      });
      this.carousel.player.addEventListener('player:resume', this.handlePlayerResume.bind(this), {
        signal: this.playerAbortController.signal,
      });
    }

    handleCarouselSelect(event) {
      this.setActiveIndex(event.detail.index);
      this.syncSlideMedia(event.detail.slide);
    }

    handleCarouselChange(event) {
      this.setActiveIndex(event.detail.index);

      if (this.dataset.videoTimingMode === 'video_duration' && event.detail.slide?.dataset.slideType === 'video') {
        return;
      }

      this.restartProgress();
    }

    handlePlayerStart() {
      this.syncDurationFromPlayer();
      this.restartProgress();
    }

    handlePlayerPause() {
      this.classList.add('is-paused');
    }

    handlePlayerResume() {
      this.syncDurationFromPlayer();
      this.classList.remove('is-paused');
      this.restartProgress();
    }

    setDuration(duration) {
      const parsedDuration = Number(duration);

      if (Number.isFinite(parsedDuration) && parsedDuration > 0) {
        this.style.setProperty('--yg-slideshow-progress-duration', `${parsedDuration}s`);
      }
    }

    setActiveIndex(activeIndex) {
      if (!this.items.length) {
        return;
      }

      const nextIndex = (activeIndex + 1) % this.items.length;
      const isMobile = this.mobileMediaQuery?.matches;

      this.items.forEach((item, index) => {
        item.hidden = !isMobile && index !== activeIndex && index !== nextIndex;
        item.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
      });
    }

    syncDurationFromPlayer() {
      if (this.dataset.videoTimingMode === 'video_duration' && this.carousel?.player) {
        this.setDuration(this.carousel.player.getDuration());
        return;
      }

      this.setDuration(this.dataset.cycleSpeed);
    }

    syncSlideMedia(selectedSlide) {
      if (this.dataset.videoTimingMode !== 'cycle_speed' || !this.carousel) {
        return;
      }

      Array.from(this.carousel.querySelectorAll('video-media')).forEach((video) => {
        video.pause?.();
      });

      const visibleVideo = Array.from(selectedSlide?.querySelectorAll('video-media') || [])
        .filter((video) => video.offsetParent !== null)
        .pop();

      visibleVideo?.play?.({ restart: true });
    }

    restartProgress() {
      const activeProgress = this.mobileMediaQuery?.matches
        ? this.querySelector('.yg-lavenne-slideshow__indicator-item[aria-current="true"] .yg-lavenne-slideshow__indicator-item-progress')
        : this.progress;

      if (this.dataset.autoplay !== 'true' || !activeProgress) {
        return;
      }

      this.syncDurationFromPlayer();
      this.classList.remove('is-playing', 'is-paused');
      this.querySelectorAll('.yg-lavenne-slideshow__indicator-progress, .yg-lavenne-slideshow__indicator-item-progress').forEach((progress) => {
        progress.getAnimations().forEach((animation) => animation.cancel());
      });

      requestAnimationFrame(() => {
        this.classList.add('is-playing');
      });
    }
  }

  if (!window.customElements.get('yg-slideshow-indicator')) {
    window.customElements.define('yg-slideshow-indicator', YGSlideshowIndicator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-spine-support-tabs"] && !Shopify.designMode) return;
  try {
    
  class YGSpineSupportTabs extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handleIntersect = this.handleIntersect.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick);
      window.addEventListener('resize', this.handleResize);
      this.prepareNumbers();
      this.initNumberObserver();
      window.requestAnimationFrame(() => this.playActiveVideo());
      window.requestAnimationFrame(() => this.updateTabIndicator());
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      window.removeEventListener('resize', this.handleResize);
      window.clearTimeout(this.videoTimer);
      window.clearTimeout(this.resizeTimer);
      this.numberObserver?.disconnect();
      this.numberAnimations?.forEach((animationFrame) => window.cancelAnimationFrame(animationFrame));
    }

    handleClick(event) {
      if (!event.target.closest('.tab-title')) {
        return;
      }

      window.clearTimeout(this.videoTimer);
      this.videoTimer = window.setTimeout(() => {
        this.pauseInactiveVideos();
        this.playActiveVideo();
      }, 160);
    }

    handleResize() {
      window.clearTimeout(this.resizeTimer);
      this.resizeTimer = window.setTimeout(() => this.updateTabIndicator(), 100);
    }

    updateTabIndicator() {
      const tabsTitle = this.querySelector('.yg-spine-support-tabs__titles');
      const activeTab = tabsTitle?.querySelector('.tab-title.is-active');

      tabsTitle?.updateStyle?.(activeTab);
    }

    prepareNumbers() {
      this.numberAnimations = new Map();

      this.querySelectorAll('.yg-spine-support-tabs__number').forEach((numberEl) => {
        const rawText = numberEl.textContent.trim();
        const match = rawText.match(/-?\d+(?:\.\d+)?/);

        if (!match) {
          return;
        }

        const target = Number(match[0]);
        const decimals = match[0].includes('.') ? match[0].split('.')[1].length : 0;

        numberEl.dataset.countPrefix = rawText.slice(0, match.index);
        numberEl.dataset.countSuffix = rawText.slice(match.index + match[0].length);
        numberEl.dataset.countTarget = String(target);
        numberEl.dataset.countDecimals = String(decimals);
        numberEl.textContent = this.formatNumber(0, decimals, numberEl.dataset.countPrefix, numberEl.dataset.countSuffix);
      });
    }

    initNumberObserver() {
      if (!('IntersectionObserver' in window)) {
        this.animateNumbers();
        return;
      }

      this.numberObserver = new IntersectionObserver(this.handleIntersect, {
        threshold: 0.65,
      });
      this.numberObserver.observe(this);
    }

    handleIntersect(entries) {
      if (!entries.some((entry) => entry.isIntersecting)) {
        return;
      }

      this.animateNumbers();
      this.numberObserver?.disconnect();
    }

    animateNumbers() {
      if (this.numbersAnimated) {
        return;
      }

      this.numbersAnimated = true;

      this.querySelectorAll('.yg-spine-support-tabs__number[data-count-target]').forEach((numberEl) => {
        this.animateNumber(numberEl);
      });
    }

    animateNumber(numberEl) {
      const target = Number(numberEl.dataset.countTarget || 0);
      const decimals = Number(numberEl.dataset.countDecimals || 0);
      const prefix = numberEl.dataset.countPrefix || '';
      const suffix = numberEl.dataset.countSuffix || '';
      const duration = 1000;
      const startTime = performance.now();

      const update = (time) => {
        const progress = Math.min((time - startTime) / duration, 1);
        const easedProgress = 1 - Math.pow(1 - progress, 3);
        const current = target * easedProgress;

        numberEl.textContent = this.formatNumber(current, decimals, prefix, suffix);

        if (progress < 1) {
          this.numberAnimations.set(numberEl, window.requestAnimationFrame(update));
          return;
        }

        numberEl.textContent = this.formatNumber(target, decimals, prefix, suffix);
        this.numberAnimations.delete(numberEl);
      };

      this.numberAnimations.set(numberEl, window.requestAnimationFrame(update));
    }

    formatNumber(value, decimals, prefix, suffix) {
      const formattedValue = decimals > 0 ? value.toFixed(decimals) : String(Math.round(value));

      return `${prefix}${formattedValue}${suffix}`;
    }

    get panels() {
      return Array.from(this.querySelectorAll('.yg-spine-support-tabs__panel'));
    }

    get activePanel() {
      return this.querySelector('.yg-spine-support-tabs__panel.is-active');
    }

    pauseInactiveVideos() {
      this.panels.forEach((panel) => {
        if (panel === this.activePanel) return;
        panel.querySelectorAll('yg-video').forEach((video) => video.pauseVideo?.());
      });
    }

    playActiveVideo() {
      this.activePanel?.querySelectorAll('yg-video').forEach((video) => video.playVideo?.());
    }
  }

  if (!window.customElements.get('yg-spine-support-tabs')) {
    window.customElements.define('yg-spine-support-tabs', YGSpineSupportTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-swiper-image"] && !Shopify.designMode) return;
  try {
    
class YGSwiperImage extends HTMLElement {
  constructor() {
    super();

    this.frameRequest = null;
    this.swiper = null;
    this.swiperEl = null;

    this.restartActiveBulletAnimation = this.restartActiveBulletAnimation.bind(this);
    this.setupMarquee = this.setupMarquee.bind(this);
    this.setupSwiperEvents = this.setupSwiperEvents.bind(this);
  }

  connectedCallback() {
    this.setupMarquee();

    this.swiperEl = this.querySelector('yg-swiper');

    if (!this.swiperEl || this.swiperEl.dataset.bulletProgressInit === 'true') return;

    this.setupSwiperEvents();
  }

  disconnectedCallback() {
    if (this.frameRequest) {
      window.cancelAnimationFrame(this.frameRequest);
      this.frameRequest = null;
    }

    if (this.swiper) {
      this.swiper.off('slideChangeTransitionStart', this.restartActiveBulletAnimation);
      this.swiper.off('paginationUpdate', this.restartActiveBulletAnimation);
    }

    if (this.swiperEl) {
      this.swiperEl.dataset.bulletProgressInit = 'false';
    }
  }

  setupSwiperEvents() {
    this.swiper = this.swiperEl?.swiper;

    if (!this.swiper) {
      this.frameRequest = window.requestAnimationFrame(this.setupSwiperEvents);
      return;
    }

    this.frameRequest = null;
    this.swiperEl.dataset.bulletProgressInit = 'true';

    this.swiper.on('slideChangeTransitionStart', this.restartActiveBulletAnimation);
    this.swiper.on('paginationUpdate', this.restartActiveBulletAnimation);

    if (this.swiper.params.autoplay) {
      this.swiper.autoplay?.start();
    }

    this.restartActiveBulletAnimation();
  }

  setupMarquee() {
    const marqueeGroup = this.querySelector('[data-yg-marquee-group]');

    if (!marqueeGroup || marqueeGroup.dataset.marqueeCloned === 'true') return;

    const marqueeClone = marqueeGroup.cloneNode(true);

    marqueeClone.setAttribute('aria-hidden', 'true');
    marqueeClone.removeAttribute('data-yg-marquee-group');

    if ('inert' in marqueeClone) {
      marqueeClone.inert = true;
    }

    marqueeGroup.after(marqueeClone);
    marqueeGroup.dataset.marqueeCloned = 'true';
    this.setMarqueeDuration(marqueeGroup);
  }

  setMarqueeDuration(marqueeGroup) {
    const slideCount = marqueeGroup.querySelectorAll('.swiper-slide').length;
    const styles = window.getComputedStyle(this);
    const slideDuration = parseFloat(styles.getPropertyValue('--yg-swiper-image-marquee-slide-duration')) || 3000;
    const totalDuration = Math.max(slideCount, 1) * slideDuration;

    this.style.setProperty('--yg-swiper-image-marquee-duration', `${totalDuration}ms`);
  }

  restartActiveBulletAnimation() {
    const activeBullet = this.swiper?.pagination?.el?.querySelector('.swiper-pagination-bullet-active');

    if (!activeBullet) return;

    activeBullet.classList.remove('is-progressing');
    activeBullet.offsetHeight;
    activeBullet.classList.add('is-progressing');
  }
}

if (!window.customElements.get('yg-swiper-image')) {
  window.customElements.define('yg-swiper-image', YGSwiperImage);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-tabs-03"] && !Shopify.designMode) return;
  try {
    
    class YGTabs03 extends HTMLElement {
      constructor() {
        super();
        this.activeIndex = 0;
        this.mediaSwiper = null;
        this.contentSwiper = null;
        this.handleTabClick = this.handleTabClick.bind(this);
        this.handleTabKeydown = this.handleTabKeydown.bind(this);
        this.handleMediaSlideChange = this.handleMediaSlideChange.bind(this);
        this.handleResize = this.handleResize.bind(this);
      }

      get sectionElements() {
        if (this._sectionElements) {
          return this._sectionElements;
        }

        this._sectionElements = {
          tabsTrack: this.querySelector('[data-tabs-track]'),
          tabsScrollContainer: this.querySelector('[data-tabs-scroll]'),
          tabs: Array.from(this.querySelectorAll('.yg-tabs-03__tab')),
          mediaSwiper: this.querySelector('[data-media-swiper]'),
          contentSwiper: this.querySelector('[data-content-swiper]'),
          contentSlides: Array.from(this.querySelectorAll('.yg-tabs-03__content-slide')),
        };

        return this._sectionElements;
      }

      connectedCallback() {
        if (this.initialized) {
          return;
        }

        this.initialized = true;

        this.sectionElements.tabs.forEach((tab) => {
          tab.addEventListener('click', this.handleTabClick);
        });

        this.sectionElements.tabsTrack?.addEventListener('keydown', this.handleTabKeydown);
        window.addEventListener('resize', this.handleResize);

        this.mountSwipers();
      }

      disconnectedCallback() {
        this.sectionElements.tabs.forEach((tab) => {
          tab.removeEventListener('click', this.handleTabClick);
        });

        this.sectionElements.tabsTrack?.removeEventListener('keydown', this.handleTabKeydown);
        window.removeEventListener('resize', this.handleResize);

        if (this.mediaSwiper) {
          this.mediaSwiper.off('slideChange', this.handleMediaSlideChange);
          this.mediaSwiper = null;
        }

        if (this.contentSwiper) {
          this.contentSwiper = null;
        }

        this.initialized = false;
      }

      mountSwipers(attempt = 0) {
        const mediaSwiperElement = this.sectionElements.mediaSwiper;
        const contentSwiperElement = this.sectionElements.contentSwiper;

        if (!mediaSwiperElement || !contentSwiperElement) {
          return;
        }

        if (!mediaSwiperElement.swiper || !contentSwiperElement.swiper) {
          if (attempt < 10) {
            window.setTimeout(() => this.mountSwipers(attempt + 1), 150);
          }
          return;
        }

        if (!this.mediaSwiper) {
          this.mediaSwiper = mediaSwiperElement.swiper;
          this.mediaSwiper.on('slideChange', this.handleMediaSlideChange);
        }

        if (!this.contentSwiper) {
          this.contentSwiper = contentSwiperElement.swiper;
        }

        this.mediaSwiper.allowTouchMove = this.sectionElements.tabs.length > 1;
        this.mediaSwiper.params.allowTouchMove = this.sectionElements.tabs.length > 1;
        this.contentSwiper.allowTouchMove = false;
        this.contentSwiper.params.allowTouchMove = false;
        this.contentSwiper.params.autoHeight = false;

        this.setActiveState(0, {
          syncSwiper: false,
          scrollBehavior: 'auto',
        });
      }

      handleTabClick(event) {
        const tab = event.currentTarget;
        const index = Number(tab.dataset.tabIndex);

        this.setActiveState(index);
      }

      handleTabKeydown(event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
          return;
        }

        const currentIndex = this.activeIndex;
        const lastIndex = this.sectionElements.tabs.length - 1;
        let nextIndex = currentIndex;

        if (event.key == 'ArrowLeft') {
          nextIndex = currentIndex > 0 ? currentIndex - 1 : lastIndex;
        } else if (event.key == 'ArrowRight') {
          nextIndex = currentIndex < lastIndex ? currentIndex + 1 : 0;
        } else if (event.key == 'Home') {
          nextIndex = 0;
        } else if (event.key == 'End') {
          nextIndex = lastIndex;
        }

        event.preventDefault();

        const nextTab = this.sectionElements.tabs[nextIndex];
        if (nextTab) {
          nextTab.focus();
        }

        this.setActiveState(nextIndex);
      }

      handleMediaSlideChange() {
        const nextIndex = typeof this.mediaSwiper.realIndex === 'number'
          ? this.mediaSwiper.realIndex
          : this.mediaSwiper.activeIndex;

        if (this.contentSwiper && this.contentSwiper.activeIndex !== nextIndex) {
          this.contentSwiper.slideTo(nextIndex);
        }

        this.setActiveState(nextIndex, {
          syncSwiper: false,
        });
      }

      handleResize() {
        this.updateOverflowState();
        this.updateIndicator();

        if (this.isTabsOverflowing()) {
          this.scrollActiveTabIntoView('auto');
        } else if (this.sectionElements.tabsScrollContainer) {
          this.sectionElements.tabsScrollContainer.scrollLeft = 0;
        }

        if (this.contentSwiper) {
          this.contentSwiper.updateAutoHeight(0);
        }
      }

      isTabsOverflowing() {
        const scrollContainer = this.sectionElements.tabsScrollContainer;

        if (!scrollContainer) {
          return false;
        }

        return scrollContainer.scrollWidth > scrollContainer.clientWidth + 1;
      }

      scrollActiveTabIntoView(behavior = 'smooth') {
        const scrollContainer = this.sectionElements.tabsScrollContainer;
        const activeTab = this.sectionElements.tabs[this.activeIndex];

        if (!activeTab || !scrollContainer) {
          return;
        }

        if (this.isTabsOverflowing()) {
          const containerRect = scrollContainer.getBoundingClientRect();
          const itemRect = activeTab.getBoundingClientRect();
          const currentScrollLeft = scrollContainer.scrollLeft;
          const rawScrollLeft = currentScrollLeft + (itemRect.left - containerRect.left) - ((scrollContainer.clientWidth - itemRect.width) / 2);
          const maxScrollLeft = Math.max(scrollContainer.scrollWidth - scrollContainer.clientWidth, 0);
          const nextScrollLeft = Math.min(Math.max(rawScrollLeft, 0), maxScrollLeft);

          if (typeof scrollContainer.scrollTo === 'function') {
            scrollContainer.scrollTo({
              left: nextScrollLeft,
              behavior: behavior,
            });
          } else {
            scrollContainer.scrollLeft = nextScrollLeft;
          }
        }
      }

      updateOverflowState() {
        const scrollContainer = this.sectionElements.tabsScrollContainer;

        if (!scrollContainer) {
          return;
        }

        scrollContainer.classList.toggle('is-overflowing', this.isTabsOverflowing());
      }

      updateIndicator() {
        const tabsTrack = this.sectionElements.tabsTrack;
        const activeTab = this.sectionElements.tabs[this.activeIndex];

        if (!tabsTrack || !activeTab) {
          return;
        }

        tabsTrack.style.setProperty('--tabs-03-indicator-left', `${activeTab.offsetLeft}px`);
        tabsTrack.style.setProperty('--tabs-03-indicator-width', `${activeTab.offsetWidth}px`);
      }

      pauseAllVideos() {
        this.querySelectorAll('.yg-tabs-03__media-slide yg-video').forEach((videoElement) => {
          if (typeof videoElement.pauseVideo === 'function') {
            videoElement.pauseVideo();
          }
        });
      }

      playActiveVideo() {
        this.pauseAllVideos();

        const activeSlide = this.querySelector(`.yg-tabs-03__media-slide[data-slide-index="${this.activeIndex}"]`);
        const activeVideo = activeSlide?.querySelector('yg-video');

        if (activeVideo && typeof activeVideo.playVideo === 'function') {
          activeVideo.playVideo();
        }
      }

      setActiveState(index, options = {}) {
        const safeIndex = Math.max(0, Math.min(index, this.sectionElements.tabs.length - 1));
        const syncSwiper = options.syncSwiper !== false;
        const scrollBehavior = options.scrollBehavior || 'smooth';

        this.activeIndex = safeIndex;

        if (syncSwiper) {
          if (this.mediaSwiper && this.mediaSwiper.activeIndex !== safeIndex) {
            this.mediaSwiper.slideTo(safeIndex);
          }

          if (this.contentSwiper && this.contentSwiper.activeIndex !== safeIndex) {
            this.contentSwiper.slideTo(safeIndex);
          }
        }

        this.sectionElements.tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === safeIndex;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        this.sectionElements.contentSlides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', slideIndex === safeIndex ? 'false' : 'true');
        });

        this.updateOverflowState();
        this.updateIndicator();

        if (this.isTabsOverflowing()) {
          this.scrollActiveTabIntoView(scrollBehavior);
        } else if (this.sectionElements.tabsScrollContainer) {
          this.sectionElements.tabsScrollContainer.scrollLeft = 0;
        }

        this.playActiveVideo();

        if (this.contentSwiper) {
          this.contentSwiper.updateAutoHeight(0);
        }
      }
    }

    if (!window.customElements.get('yg-tabs-03')) {
      window.customElements.define('yg-tabs-03', YGTabs03);
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-timeline"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    class YGTimeline extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
      }

      connectedCallback() {
        this.initSwiper();
      }

      initSwiper() {
        this.swiper = new Swiper(this.querySelector('.swiper'), {
          breakpoints: {
            200: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            1070: {
              slidesPerView: 'auto',
              spaceBetween: 12,
            },
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            type: 'bullets',
            clickable: true,
            renderBullet: (index, className) => {
              const time =
                this.querySelector('.swiper').swiper?.slides[index]?.dataset.time || index + 1;
              return `<div class="${className} yg-timeline-bullet">${time}</div>`;
            },
          },
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          on: {
            init: (swiper) => {
              this.updateSlideWidth(swiper);
              this.handlePaginationScroll(swiper);
            },
            resize: (swiper) => {
              this.updateSlideWidth(swiper);
              this.handlePaginationScroll(swiper);
            },
          }
        });
      }

      handlePaginationScroll(swiper) {
        if (window.innerWidth <= 1069) {
          const pagination = this.querySelector('.swiper-pagination');
          if (!pagination) return;

          pagination.addEventListener('click', (e) => {
            const bullet = e.target.closest('.swiper-pagination-bullet');
            if (bullet) {
              const containerRect = pagination.getBoundingClientRect();
              const bulletRect = bullet.getBoundingClientRect();
              const scrollLeft = pagination.scrollLeft;
              const targetScrollLeft = scrollLeft + bulletRect.left - containerRect.left - (containerRect.width / 2) + (bulletRect.width / 2);

              pagination.scrollTo({
                left: targetScrollLeft,
                behavior: 'smooth'
              });
            }
          }, true);
        }
      }

      updateSlideWidth(swiper) {
        setTimeout(() => {
          swiper.slides.forEach(slide => {
            const width = slide.style.width;
            slide.style.setProperty('--swiper-slide-width', width);
          });
        }, 0);
      }
    }
    if (!window.customElements.get('yg-timeline')) {
      window.customElements.define('yg-timeline', YGTimeline);
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-list-02"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", ()=>{
    class YGVideoList02 extends HTMLElement {
        constructor() {
            super()
            this.handleTabClick = this.handleTabClick.bind(this)
        }
        connectedCallback() {
          const ygSwiper = this.querySelector('yg-swiper').swiper;
          if (!ygSwiper) return;
          this.swiper = ygSwiper;
          this.addEventListener('click', this.handleTabClick);
          ygSwiper.on('slideChangeTransitionEnd', (e) => {
            this.switchVideoStatus(e)
            this.syncTabs(e.realIndex ?? e.activeIndex)
          });
          this.syncTabs(ygSwiper.realIndex ?? ygSwiper.activeIndex ?? 0)
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleTabClick);
        }

        handleTabClick(e) {
          const tab = e.target.closest('.yg-video-list-02-tabs__title');
          if (!tab || !this.contains(tab) || !this.swiper) return;

          const index = Number(tab.dataset.swiperIndex);
          if (Number.isNaN(index)) return;

          if (typeof this.swiper.slideToLoop === 'function') {
            this.swiper.slideToLoop(index);
          } else {
            this.swiper.slideTo(index);
          }
        }

        syncTabs(index) {
          const tabs = Array.from(this.querySelectorAll('.yg-video-list-02-tabs__title'));
          const contents = Array.from(this.querySelectorAll('.yg-video-list-02-tabs__content'));
          const tabCount = tabs.length;
          if (!tabCount) return;

          const rawIndex = Number(index) || 0;
          const activeIndex = ((rawIndex % tabCount) + tabCount) % tabCount;

          tabs.forEach((tab, tabIndex) => {
            tab.classList.toggle('is-active', tabIndex === activeIndex);
          });
          contents.forEach((content, contentIndex) => {
            content.classList.toggle('is-active', contentIndex === activeIndex);
          });

          const activeTab = tabs[activeIndex];
          activeTab?.closest('yg-tabs-title')?.updateStyle?.(activeTab);
        }

        switchVideoStatus(e){
          // 从 e 对象中获取当前激活块
          const currentSlide = e.slides[e.activeIndex];
          // 若要获取 block id，假设每个 slide 有 data-block-id 属性
          const currentBlockId = currentSlide ? currentSlide.dataset.blockId : null;
          e.slides.forEach((slide) => {
            const video = slide.querySelector('yg-video');
            if (video && typeof video.pauseVideo === 'function') {
              video.pauseVideo();
            }
          })
          
          const video = currentSlide.querySelector('yg-video');
          if (video && typeof video.playVideo === 'function') {
            video.playVideo();
          }
        }
    }
    if (!window.customElements.get('YGVideoList02')) {
        window.customElements.define('yg-video-list-02',YGVideoList02)
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-whats-in-box"] && !Shopify.designMode) return;
  try {
    
  class YGWhatsInBox extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.yg-whats-in-box__viewport');
      this.progress = this.querySelector('.yg-whats-in-box__progress');
      this.thumb = this.querySelector('.yg-whats-in-box__progress-thumb');

      if (!this.viewport || !this.progress || !this.thumb) {
        return;
      }

      this.updateProgress = this.updateProgress.bind(this);
      this.viewport.addEventListener('scroll', this.updateProgress, { passive: true });
      window.addEventListener('resize', this.updateProgress);
      this.updateProgress();
    }

    disconnectedCallback() {
      this.viewport?.removeEventListener('scroll', this.updateProgress);
      window.removeEventListener('resize', this.updateProgress);
    }

    updateProgress() {
      const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;

      if (maxScroll <= 0) {
        this.progress.hidden = true;
        return;
      }

      this.progress.hidden = false;

      const trackWidth = this.progress.clientWidth;
      const visibleRatio = this.viewport.clientWidth / this.viewport.scrollWidth;
      const thumbWidth = Math.max(trackWidth * visibleRatio, 40);
      const travel = Math.max(trackWidth - thumbWidth, 0);
      const progress = this.viewport.scrollLeft / maxScroll;

      this.thumb.style.setProperty('--yg-wib-progress-width', `${thumbWidth}px`);
      this.thumb.style.setProperty('--yg-wib-progress-left', `${travel * progress}px`);
    }
  }

  if (!window.customElements.get('yg-whats-in-box')) {
    window.customElements.define('yg-whats-in-box', YGWhatsInBox);
  }

  } catch(e) { console.error(e); }
})();
})();
